import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=35226aef&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=35226aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35226aef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35226aef')) {
      api.createRecord('35226aef', component.options)
    } else {
      api.reload('35226aef', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=35226aef&scoped=true&", function () {
      api.rerender('35226aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/comp/DocBox.vue"
export default component.exports